export const SET_OPEN_TAB = 'TABS_OPEN_TAB';
export const SET_OPEN_SUBTAB = 'TABS_OPEN_SUBTAB';
export const REMOVE_TABS = 'TABS_REMOVE';
export const TABS_REGISTER_ANCHOR = 'TABS_REGISTER_ANCHOR';
export const TABS_UNREGISTER_ANCHOR = 'TABS_UNREGISTER_ANCHOR';
export const TABS_URL_PARAM = 'tab';
